import { Component, OnInit, AfterViewInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ChangeDetectorRef } from '@angular/core';
import { CommonService } from '../../../services/index';

@Component({
    selector: 'tally-sync-status-tab',
    templateUrl: './tallySyncStatus.component.html',
    styleUrls: ['./tallySyncStatus.component.css']
})
export class TallySyncStatusComponent implements OnInit, AfterViewInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input('params') params: string;
    @ViewChild('filterPanel') filterPanel;
    @ViewChild('statusTemplate') statusTemplate: TemplateRef<any>;
    @ViewChild('actionsTemplate') actionsTemplate: TemplateRef<any>;
    @ViewChild('actionTypeTemplate') actionTypeTemplate: TemplateRef<any>;
    @ViewChild('retryTemplate') retryTemplate: TemplateRef<any>;

    filterData: any = {};
    filterExpand = false;
    reportData: any[] = [];
    gloRepDataArr: any[] = [];
    columns: any[] = [];
    loading = false;
    isLoadMask: Promise<any>;
    loadingIndicator: boolean = true;
    page = {
        limit: 50,
        count: 0,
        offset: 0,
        orderBy: 'created_at',
        orderDir: 'desc'
    };
    footerDataObj: any = [];
    showSumFooter: boolean = false;
    usertype: string = '';
    summaryStats: any = { total: 0, pending: 0, synced: 0, failed: 0 };
    branchList: any[] = [];

    // Filter options
    screenNameOptions: { value: string, text: string }[] = [
        { value: '', text: 'All Modules' }
    ];

    statusOptions = [
        { value: '', text: 'All Status' },
        { value: 'Open', text: 'Pending Sync' },
        { value: 'Synced', text: 'Successfully Synced' }
    ];

    constructor(
        private http: HttpClient,
        private commonService: CommonService,
        private cd: ChangeDetectorRef
    ) {
        this.initializeColumns();
    }

    ngOnInit() {
        this.setDefaultDates();
        this.loadScreenNames();
        this.loadBranchList();
    }

    ngAfterViewInit() {
        this.initializeColumns();
        this.getReports();
        this.loadSummaryStats();
        this.cd.detectChanges();
    }

    initializeColumns() {
        this.columns = [
            { name: 'Screen', prop: 'screen_name', width: 130 },
            { name: 'Branch', prop: 'branch_name', width: 130 },
            { name: 'Date', prop: 'formatted_date', width: 100 },
            { name: 'Auto No', prop: 'voucher_no', width: 100 },
            { name: 'Action Type', prop: 'operation_type', width: 150, cellTemplate: this.actionTypeTemplate },
            { name: 'Last Attempt', prop: 'last_attempt', width: 150 },
            { name: 'Error Details', prop: 'error_message', width: 200 },
            { name: 'Retry', prop: 'retry_count', width: 100, cellTemplate: this.retryTemplate },
            { name: 'Status', prop: 'sync_status', width: 110, cellTemplate: this.statusTemplate },
            { name: 'Actions', prop: 'actions', width: 100, cellTemplate: this.actionsTemplate }
        ];
    }

    checkCustomTemp() {
        for (let i = 0; i < this.columns.length; i++) {
            let tempName = this.columns[i].cellTemplateName;
            if (tempName === 'statusTemplate') {
                this.columns[i]['cellTemplate'] = this.statusTemplate;
            } else if (tempName === 'actionsTemplate') {
                this.columns[i]['cellTemplate'] = this.actionsTemplate;
            } else if (tempName === 'actionTypeTemplate') {
                this.columns[i]['cellTemplate'] = this.actionTypeTemplate;
            } else if (tempName === 'retryTemplate') {
                this.columns[i]['cellTemplate'] = this.retryTemplate;
            }
        }
        this.columns = [...this.columns];
    }

    setDefaultDates() {
        const today = new Date();
        const lastWeek = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);

        this.filterData = {
            search_name: '',
            screen_name: '',
            sync_status: '',
            branch_id: '',
            from_date: lastWeek,
            to_date: today
        };
        this.page.offset = 0;
        this.page.count = 0;
    }

    onOpenedFilter(): void {
        const that = this;
        setTimeout(function () {
            const searchInput = document.getElementById('filterSearch');
            if (searchInput) {
                searchInput.focus();
            }
        }, 100);
    }

    loadSummaryStats() {
        let params = new HttpParams()
            .set('screen_name', this.filterData.screen_name || '')
            .set('from_date', this.filterData.from_date ? moment(this.filterData.from_date).format('YYYY-MM-DD') : '')
            .set('to_date', this.filterData.to_date ? moment(this.filterData.to_date).format('YYYY-MM-DD') : '');

        this.http.get('api/tallySyncStatus/getSummaryStats', { params }).subscribe(
            (response: any) => {
                if (response.success && response.data) {
                    const d = response.data;
                    this.summaryStats = {
                        total: d.total || 0,
                        pending: d.pending || 0,
                        synced: d.synced || 0,
                        failed: (d.pending || 0) > 0 ? (d.failed || 0) : 0
                    };
                    this.cd.detectChanges();
                }
            },
            (error) => { console.error('Error loading summary stats:', error); }
        );
    }

    loadBranchList() {
        this.commonService.getBranchList().subscribe(
            (res: any) => { this.branchList = res.data || []; },
            (error) => { console.error('Error loading branch list:', error); }
        );
    }

    loadScreenNames() {
        this.http.get('api/tallySyncStatus/getScreenNames').subscribe(
            (response: any) => {
                if (response.success && response.data) {
                    this.screenNameOptions = [{ value: '', text: 'All Modules' }].concat(
                        response.data.map((name: string) => ({ value: name, text: name }))
                    );
                }
            },
            (error) => {
                console.error('Error loading screen names:', error);
            }
        );
    }

    getSyncStatusList() {
        this.getReports();
    }

    getReports() {
        this.loadingIndicator = true;

        let params = new HttpParams()
            .set('page', (this.page.offset + 1).toString())
            .set('limit', this.page.limit.toString())
            .set('search_name', this.filterData.search_name || '')
            .set('screen_name', this.filterData.screen_name || '')
            .set('sync_status', this.filterData.sync_status || '')
            .set('branch_id', this.filterData.branch_id || '')
            .set('from_date', this.filterData.from_date ? moment(this.filterData.from_date).format('YYYY-MM-DD') : '')
            .set('to_date', this.filterData.to_date ? moment(this.filterData.to_date).format('YYYY-MM-DD') : '');

        this.isLoadMask = this.http.get('api/tallySyncStatus/getSyncStatusList', { params }).toPromise();
        this.isLoadMask.then(
            (response: any) => {
                if (response.success) {
                    this.reportData = response.data;
                    this.page.count = response.total;
                } else {
                    console.error('Failed to load sync status data:', response.message);
                }
                this.loadingIndicator = false;
                this.cd.detectChanges();
            },
            (error) => {
                console.error('Error loading sync status data:', error);
                this.loadingIndicator = false;
            }
        );
    }

    applyFilter() {
        if (this.filterPanel) {
            this.filterPanel.close();
        }
        this.page.offset = 0;
        this.getReports();
        this.loadSummaryStats();
    }

    clearFilter() {
        this.filterData = {
            "search_name": '',
            "from_date": new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
            "to_date": new Date(),
            "screen_name": '',
            "sync_status": '',
            "branch_id": ''
        };
        this.applyFilter();
    }

    resetToOpen(logId: number, entryDetails: string) {
        let that = this;
        swal({
            title: 'Change Sync Status?',
            text: `Are you sure you want to change the sync status for "${entryDetails}"? This will archive the current history and create a fresh sync attempt with the latest data.`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, change it!',
            cancelButtonText: 'No, keep it'
        }).then(function () {
            const params = { log_id: logId };
            that.http.post('api/tallySyncStatus/resetToOpen', params).subscribe(
                (response: any) => {
                    if (response.success) {
                        swal('Success', response.message || 'New sync entry created successfully!', 'success');
                        that.getReports();
                    } else {
                        swal('Error', 'Failed to create entry: ' + response.message, 'error');
                    }
                },
                (error) => {
                    console.error('Error in resync:', error);
                    swal('Error', 'An error occurred. Please try again.', 'error');
                }
            );
        }, function (dismiss) {
            // User cancelled
        });
    }

    selectedItemDetails: any = null;
    showDetailsModal = false;
    jsonCopied = false;

    viewDetails(item: any) {
        this.selectedItemDetails = item;
        this.showDetailsModal = true;
    }

    closeDetailsModal() {
        this.showDetailsModal = false;
        this.selectedItemDetails = null;
        this.jsonCopied = false;
    }

    onKeyDown(event: KeyboardEvent) {
        if (event.key === 'Escape' && this.showDetailsModal) {
            this.closeDetailsModal();
        }
    }

    copyJsonData(jsonString: string) {
        const formatted = this.formatJsonData(jsonString);
        const nav = navigator as any;
        if (nav.clipboard) {
            nav.clipboard.writeText(formatted).then(() => {
                this.jsonCopied = true;
                setTimeout(() => { this.jsonCopied = false; }, 2000);
            });
        } else {
            const el = document.createElement('textarea');
            el.value = formatted;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this.jsonCopied = true;
            setTimeout(() => { this.jsonCopied = false; }, 2000);
        }
    }

    formatJsonData(jsonString: string): string {
        if (!jsonString) return 'No data available';
        try {
            const parsed = JSON.parse(jsonString);
            return JSON.stringify(parsed, null, 2);
        } catch (e) {
            return jsonString;
        }
    }

    bulkResetFailed() {
        if (confirm('Are you sure you want to reset ALL failed entries to Open status?')) {
            const filters = {
                screen_name: this.filterData.screen_name || '',
                from_date: this.filterData.from_date ? moment(this.filterData.from_date).format('YYYY-MM-DD') : '',
                to_date: this.filterData.to_date ? moment(this.filterData.to_date).format('YYYY-MM-DD') : ''
            };

            this.http.post('api/tallySyncStatus/bulkResetFailed', filters).subscribe(
                (response: any) => {
                    if (response.success) {
                        alert(`${response.count} entries have been reset successfully!`);
                        this.getReports();
                    } else {
                        alert('Failed to bulk reset: ' + response.message);
                    }
                },
                (error) => {
                    console.error('Error in bulk reset:', error);
                    alert('Error in bulk reset. Please try again.');
                }
            );
        }
    }

    exportReport() {
        const columns = [
            { prop: 'screen_name', name: 'Screen' },
            { prop: 'formatted_date', name: 'Date' },
            { prop: 'operation_type', name: 'Operation' },
            { prop: 'sync_status', name: 'Status' },
            { prop: 'narration', name: 'NARRATION (Description)' },
            { prop: 'last_attempt', name: 'Last Attempt' },
            { prop: 'error_message', name: 'Error Details' }
        ];

        const data = {
            columns: JSON.stringify(columns),
            data: JSON.stringify(this.gloRepDataArr),
            title: 'Tally Sync Status Report'
        };

        this.commonService.printing(data).then((res: any) => {
            if (res['_body']) {
                const headers = res['headers']['_headers'];
                const ctype = headers.get('content-type')[0];
                const cdispos = headers.get('content-disposition')[0];
                const filename = cdispos.replace(/attachment;filename=|"/gi, '');
                const blob = new Blob([res['_body']], { type: ctype });
                const link = document.createElement('a');

                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    (window.navigator as any).msSaveOrOpenBlob(blob, filename);
                } else {
                    const url = window.URL.createObjectURL(blob);
                    link.href = url;
                    link.download = filename;
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch((error) => {
            console.error('Error exporting report:', error);
            alert('Error exporting report. Please try again.');
        });
    }

    getStatusBadgeClass(status: string, retryCount: number = 0): string {
        if (status === 'Open') {
            return retryCount > 3 ? 'tss-badge tss-badge-failed' : 'tss-badge tss-badge-pending';
        }
        return 'tss-badge tss-badge-synced';
    }

    getStatusText(status: string, retryCount: number = 0): string {
        if (status === 'Open') {
            return retryCount > 3 ? 'Failed' : 'Pending';
        }
        return 'Synced';
    }

    getActionTypeBadgeClass(actionType: string): string {
        if (actionType === 'Add') return 'tss-type-badge tss-type-add';
        if (actionType === 'Update' || actionType === 'Edit') return 'tss-type-badge tss-type-update';
        if (actionType === 'Delete') return 'tss-type-badge tss-type-delete';
        return 'tss-type-badge';
    }

    displayBranch(branchId: any) {
        if (!branchId) return '';
        const branch = _.find(this.branchList, { branch_id: branchId });
        return branch ? branch.branch_name : '';
    }

    getRowClass(row) {
        return {
            'grid-foot-total-row': row.footRow == true
        };
    }

    pageCallback(event: any) {
        this.page.offset = event.offset;
        this.getReports();
    }

    onChangePageSize(limit: number) {
        this.page.limit = limit;
        this.page.offset = 0;
        this.getReports();
    }
}

// Set the component name for dynamic loading
Object.defineProperty(TallySyncStatusComponent, 'name', {
    value: 'TallySyncStatusComponent'
});


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/dataCorrection/tallySyncStatus/tallySyncStatus.component.ts